import moment from 'moment';

export default function formatDate(userInitials: string): string {
  return `${userInitials} ${moment().format('YYMMDD-HHmm')}`;
}
